import { Alert, Box, Button, Container, IconButton, Snackbar, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import 'react-slideshow-image/dist/styles.css'
import EditComp from "../util/EditComp";
import Service from "../../util/Service";
import ContentPage from "../page/portal/ContentPage";
import EditarPaginaHtml from "../page/editar/EditarPaginaHtml";
import { useProfile } from "../common/useProfile";
import HomeIcon from '@mui/icons-material/Home';
import { ContactPage } from "@mui/icons-material";

export const ShowWait=()=>{
    return (
    <div style={{
            textAlign: 'center', 
            alignItems: 'center', 
            justifyContent: 'center', 
            display: 'flex',
            width: '100vw',
            height: '85vh'
        }}
        >
            <Typography variant="h4">Aguarde!</Typography>
        </div>
    )
}
export default function Home(props) {
    const { layout, darkMode, handleDarkMode, edit, setEdit } = props;
    const location = useLocation();
    
    const navigate = useNavigate();
    const { state } = location;
    const themeDf = useTheme();
    const [message, setMessage] = useState(state?.message);
    const [messageType, setMessageType] = useState(state?.type);
    const [open, setOpen] = React.useState(false);
    const [pagina, setPagina] = React.useState();
    const [paginaPessoal, setPaginaPessoal] = React.useState();
    const [wait, setWait] = React.useState(false);
    const [openEditar, setOpenEditar] = React.useState(false);
    const prof = useProfile();
    const [irPaginaHomePorta, setIrPaginaHomePortal] = React.useState(false);

    React.useEffect(() => {
        if (layout) {
            console.log('w1')
            setWait(true);
            const h = layout.body.pagina || 'Body';
            Service.GET('/api/paginaHtml/buscaPorNome/' + h).then(r => {
                if (r && r.length > 0) {
                    setPagina(r[0]);
                }
                setTimeout(() => {
                    //aguarda um pouco para conclur a montatem do status da paginaRoot
                    console.log('w2')
                    setWait(false)    
                }, 300);
                
            });
        }
    }, [layout])
    useEffect(() => {
        if (state?.message) {
            setOpen(true);
            setMessage(state.message);
            setMessageType(state.type);
            const timer = setTimeout(() => {
                navigate(location.pathname, { state: {} });
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [state]);
    useEffect(() => {
        if (prof.isOk && pagina) {
            console.log('w3')
            setWait(true);
            Service.GET('/api/paginaHtml/buscaPorNome/' + prof.profile.id).then(r => {
                if (r && r.length > 0) {
                    setPaginaPessoal(r[0]);
                }
                console.log('w4')
                setWait(false)
            });
        }
    }, [prof.profile, pagina])

    const handleEditarPagina = () => {
        if (!pagina) {
            let dado = {
                nome: layout.body,
                descricao: 'Pagina Home'
            }
            Service.POST("/api/security/paginaHtml", dado).then(r => {
                setPagina(r);
                setOpenEditar(true);
            }).catch(e => {
                console.log("erro--->", e)
                alert(e);
                localStorage.setItem("localStorage", location.pathname);
                navigate("/login");
            })
        } else {
            setOpenEditar(true);
        }
    }
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };
    function handelDoAction(retorno) {
        setPagina(retorno);
    }
    if (wait) {        
        return (
            <ShowWait />
        )
    }
    if (!pagina) {
        if( !layout) return;
        return (
            <Container fixed maxWidth="xl" sx={{ marginTop: 5 }}>
                <EditComp tip="Editar Pagina" action={handleEditarPagina} edit={edit} />
                Pagina padrão, cadastre uma pagina chamada <a href="/recursos">{layout.body}</a>

            </Container>
        )
    }
    
    function montaPagina() {      
        if( location.pathname === "/home"){
            return(
                <ContentPage pagina={pagina} edit={edit} />
            )
        }
        if (prof.isOk && prof.profile && prof.profile.paginaHome && !irPaginaHomePorta) {
            console.log(prof.profile.paginaHome)
            
            if (prof.profile.paginaHome.charAt(0) === "/") {
                setTimeout(() => {
                    navigate(prof.profile.paginaHome, {state: {showGoToHome: true}
                    });
                }, 30);
                console.log(2);
                return(
                    <ShowWait />
                )
            }
            return (
                <div >
                    <div style={{ float: "right", marginRight: '5px' }}>
                        <Tooltip title="Ir para pagina home do portal">
                            <IconButton aria-label="edit" color="primary"
                                //sx={{ float: 'left', ml: -5, mt: -1 }}
                                onClick={() => setIrPaginaHomePortal(true)}
                            //onClick={()=> console.log('>>>>>>')}
                            >
                                <HomeIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <ContentPage pagina={prof.profile.paginaHome} edit={edit} />
                </div>
            )
        }
        if (!prof.temAcesso("MinhaPagina")) {
            return (
                <ContentPage pagina={pagina} edit={edit} />
            )
        }
        if (paginaPessoal && !irPaginaHomePorta) {
            //style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}
            return (
                <div>
                    <div style={{ 
                            position: "absolute",
                            top: "60px",
                            right: "5px"
                     }}>
                        <Tooltip title="Ir para pagina home do portal2">
                            <IconButton aria-label="edit" color="inherit"
                                onClick={() => setIrPaginaHomePortal(true)}
                            >
                                <HomeIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <ContentPage pagina={paginaPessoal} edit={edit} />
                </div>
            )
        }
        return (
            <div>
                {paginaPessoal &&
                    <div className="vr-float-dir">
                        <Tooltip title="Ir para pagina pessoal">
                            <IconButton aria-label="edit" 
                            // color="inherit"
                                sx={{color: themeDf.palette.common.white}}
                                onClick={() => setIrPaginaHomePortal(false)}
                            >
                                <ContactPage />
                            </IconButton>
                        </Tooltip>
                    </div>}
                <ContentPage pagina={pagina} edit={edit} />
            </div>
        )
    }
    
    return (
        <React.Fragment>

            <EditComp tip="Editar Pagina" action={handleEditarPagina} edit={edit} />
            {montaPagina()}

            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={messageType}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {message}
                </Alert>
            </Snackbar>
            <EditarPaginaHtml open={openEditar} setOpen={setOpenEditar} doAction={handelDoAction} pagina={pagina} />

        </React.Fragment>
    );
}

